
function printInspection(companykey,oid) {
    newwindow=window.open('/'+companykey+'/orders/print/'+oid,'name','height=640,width=1150,scrollbars=yes');
    if (window.focus) {newwindow.focus()}
    return false;
}

function officeChangerInit() {
    var pos = $('#menuBar').position();
    var yy = pos.top + $('#menuBar').height();
    var xx = ($('#menuBar').width() - $('#officeChanger').width()) / 2;
    $('#officeChanger').css('left', xx);
    $('#officeChanger').css('top', yy);
}
function officeChanger() {
    officeChangerInit();
    if( $('#officeChanger').is(':visible') ) {
        $('#officeChanger').fadeOut('slow');
    } else {
        $('#officeChanger').fadeIn('slow');
    }
}

// spm - hard to tell if this stuff is still used - it is referenced at least in scripts/ajax/popup.js, and that file may no longer actually be in use too.
var isnUIwindowWidth = '';
var isnUIwindowHeight = '';
var isnUIquickAccessContainer = 'isnUIquickAccessContainer';

var isnUIquickAccessContainerClass = 'isnUIquickAccessContainer';
var isnUIquickAccessContainerClassHide = isnUIquickAccessContainerClass + 'Hide';

var isnUIeventX = 0;
var isnUIeventY = 0;
var isnUIevent = '';
var isnUIdocWidth = null;
var isnUIdocHeight = null;

function isnUIinit() {
    isnUIwindowWidth = $(window).width();;
    isnUIwindowHeight = $(window).height();
}

function isnUIeventClick(event) {
    isnUIevent = event;
    isnUIeventX = event.pageX;
    isnUIeventY = event.pageY;
}

function isnUIclickContainerLoad(containerDivName, uri, callback) {
    var containerDiv = isnUIquickAccessContainer;
    var containerDivHide = containerDiv + 'Hide';

    $('#' + containerDivHide).remove();
    $('#' + containerDivName).remove();
    $('body').append('<div id="' + containerDivHide + '" class="' + isnUIquickAccessContainerClassHide + '"></div>');
    $('#' + containerDivHide).load(uri, function(){
        isnUIclickContainerCloneSetPosition(containerDivName, isnUIevent.pageX, isnUIevent.pageY);
        $('#' + containerDivName).fadeIn(400, callback);
    });
}

function isnUIclickContainerCloneSetPosition(containerDivName, x, y) {
    var containerDiv = isnUIquickAccessContainer;
    var containerDivHide = containerDiv + 'Hide';
    if (isnUIdocWidth == null) isnUIdocWidth = $(document).width();
    if (isnUIdocHeight == null) isnUIdocHeight = $(document).height();

    var width = $('#' + containerDivHide).width();
    var height = $('#' + containerDivHide).height();

    newX = 0;
    newY = 0;

    if (isnUIdocWidth > width+20) {
        if (isnUIdocWidth < ( x+width+20 )) {
            newX = isnUIdocWidth - width - 20;
        } else {
            newX = x;
        }
    }

    if (isnUIdocHeight > height+20) {
        if (isnUIdocHeight < ( y+height+20 )) {
            newY = isnUIdocHeight - height - 20;
        } else {
            newY= y;
        }
    }

    $('#' + containerDiv).remove();
    $('body').append('<div id="' + containerDiv + '" class="' + isnUIquickAccessContainerClass + '"></div>');
    $('#' + containerDiv).css('top', newY);
    $('#' + containerDiv).css('left', newX);
    $('#' + containerDiv).html($('#' + containerDivHide).html());
    $('#' + containerDiv).attr('id', containerDivName);
    $('#' + containerDivHide).remove();
    $('#' + containerDivName).draggable();
}

function isnUIclickContainerRemove(containerDiv, callback) {
    $('#' + containerDiv).fadeOut(400, callback);
    $('#' + containerDiv).remove();
}


function jQfSubmit(form) {
    if ($('#'+form).length) var formID = '#'+form;
    else var formID = '#'+form.id;
    var form2submit = $(formID);
    form2submit.submit();
}

function jQfValidate(form) {
    if ($('#'+form).length) var formID = '#'+form;
    else var formID = '#'+form.id;
    validator = $(formID).validate(jQValidationArr);
    if($(formID).valid()) {
        return true;
    } else {
        return false;
    }
}

$( function() {
    isnUIinit();
});



function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}


(function($) {
    $.fn.textboxhint = function(userOptions) {
        var options = $.extend({}, $.fn.textboxhint.defaults, userOptions);
        return $(this).filter(':text,textarea').each(function(){
            if ($(this).val() == '') {
                $(this).focus(function(){
                    if ($(this).attr('typedValue') == '') {
                        $(this).removeClass(options.classname).val('');
                    }
                }).blur(function(){
                    $(this).attr('typedValue', $(this).val());
                    if ($(this).val() == '') {
                        $(this).addClass(options.classname).val(options.hint);
                    }
                }).blur();
            }
        });
    };

    $.fn.textboxhint.defaults = {
        hint: 'Please enter a value',
        classname: 'hint'
    };

    /*

     highlight v3

     Highlights arbitrary terms.

     <http://johannburkard.de/blog/programming/javascript/highlight-javascript-text-higlighting-jquery-plugin.html>

     MIT license.

     Johann Burkard
     <http://johannburkard.de>
     <mailto:jb@eaio.com>

     */

    jQuery.fn.highlight = function(pat,classname) {
        function innerHighlight(node, pat) {
            var skip = 0;
            if (node.nodeType == 3) {
                var pos = node.data.toUpperCase().indexOf(pat);
                if (pos >= 0) {
                    var spannode = document.createElement('span');
                    spannode.className = classname;
                    var middlebit = node.splitText(pos);
                    var endbit = middlebit.splitText(pat.length);
                    var middleclone = middlebit.cloneNode(true);
                    spannode.appendChild(middleclone);
                    middlebit.parentNode.replaceChild(spannode, middlebit);
                    skip = 1;
                }
            }
            else if (node.nodeType == 1 && node.childNodes && !/(script|style)/i.test(node.tagName)) {
                for (var i = 0; i < node.childNodes.length; ++i) {
                    i += innerHighlight(node.childNodes[i], pat);
                }
            }
            return skip;
        }
        return this.each(function() {
            innerHighlight(this, pat.toUpperCase());
        });
    };

})(jQuery);



/**
 * Storage plugin
 * Provides a simple interface for storing data such as user preferences.
 * Storage is useful for saving and retreiving data from the user's browser.
 * For newer browsers, localStorage is used.
 * If localStorage isn't supported, then cookies are used instead.
 * Retrievable data is limited to the same domain as this file.
 *
 * Usage:
 * This plugin extends jQuery by adding itself as a static method.
 * $.Storage - is the class name, which represents the user's data store, whether it's cookies or local storage.
 *             <code>if ($.Storage)</code> will tell you if the plugin is loaded.
 * $.Storage.set("name", "value") - Stores a named value in the data store.
 * $.Storage.set({"name1":"value1", "name2":"value2", etc}) - Stores multiple name/value pairs in the data store.
 * $.Storage.get("name") - Retrieves the value of the given name from the data store.
 * $.Storage.remove("name") - Permanently deletes the name/value pair from the data store.
 *
 * @author Dave Schindler
 *
 * Distributed under the MIT License
 *
 * Copyright (c) 2010 Dave Schindler
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
(function($) {
    // Private data
    var isLS=typeof window.localStorage!=='undefined';
    // Private functions
    function wls(n,v){var c;if(typeof n==="string"&&typeof v==="string"){localStorage[n]=v;return true;}else if(typeof n==="object"&&typeof v==="undefined"){for(c in n){if(n.hasOwnProperty(c)){localStorage[c]=n[c];}}return true;}return false;}
    function wc(n,v){var dt,e,c;dt=new Date();dt.setTime(dt.getTime()+31536000000);e="; expires="+dt.toGMTString();if(typeof n==="string"&&typeof v==="string"){document.cookie=n+"="+v+e+"; path=/";return true;}else if(typeof n==="object"&&typeof v==="undefined"){for(c in n) {if(n.hasOwnProperty(c)){document.cookie=c+"="+n[c]+e+"; path=/";}}return true;}return false;}
    function rls(n){return localStorage[n];}
    function rc(n){var nn, ca, i, c;nn=n+"=";ca=document.cookie.split(';');for(i=0;i<ca.length;i++){c=ca[i];while(c.charAt(0)===' '){c=c.substring(1,c.length);}if(c.indexOf(nn)===0){return c.substring(nn.length,c.length);}}return null;}
    function dls(n){return delete localStorage[n];}
    function dc(n){return wc(n,"",-1);}

    /**
     * Public API
     * $.Storage - Represents the user's data store, whether it's cookies or local storage.
     * $.Storage.set("name", "value") - Stores a named value in the data store.
     * $.Storage.set({"name1":"value1", "name2":"value2", etc}) - Stores multiple name/value pairs in the data store.
     * $.Storage.get("name") - Retrieves the value of the given name from the data store.
     * $.Storage.remove("name") - Permanently deletes the name/value pair from the data store.
     */
    $.extend({
        Storage: {
            set: isLS ? wls : wc,
            get: isLS ? rls : rc,
            remove: isLS ? dls :dc
        }
    });
})(jQuery);

/** sha256 implementation
 * Source: http://geraintluff.github.io/sha256/
 */
var sha256=function a(b){function c(a,b){return a>>>b|a<<32-b}for(var d,e,f=Math.pow,g=f(2,32),h="length",i="",j=[],k=8*b[h],l=a.h=a.h||[],m=a.k=a.k||[],n=m[h],o={},p=2;64>n;p++)if(!o[p]){for(d=0;313>d;d+=p)o[d]=p;l[n]=f(p,.5)*g|0,m[n++]=f(p,1/3)*g|0}for(b+="\x80";b[h]%64-56;)b+="\x00";for(d=0;d<b[h];d++){if(e=b.charCodeAt(d),e>>8)return;j[d>>2]|=e<<(3-d)%4*8}for(j[j[h]]=k/g|0,j[j[h]]=k,e=0;e<j[h];){var q=j.slice(e,e+=16),r=l;for(l=l.slice(0,8),d=0;64>d;d++){var s=q[d-15],t=q[d-2],u=l[0],v=l[4],w=l[7]+(c(v,6)^c(v,11)^c(v,25))+(v&l[5]^~v&l[6])+m[d]+(q[d]=16>d?q[d]:q[d-16]+(c(s,7)^c(s,18)^s>>>3)+q[d-7]+(c(t,17)^c(t,19)^t>>>10)|0),x=(c(u,2)^c(u,13)^c(u,22))+(u&l[1]^u&l[2]^l[1]&l[2]);l=[w+x|0].concat(l),l[4]=l[4]+w|0}for(d=0;8>d;d++)l[d]=l[d]+r[d]|0}for(d=0;8>d;d++)for(e=3;e+1;e--){var y=l[d]>>8*e&255;i+=(16>y?0:"")+y.toString(16)}return i};